<template>
  <div>
    <Header/>
    <Navigationzj/>
    <div class="h_zp_zx" style="margin-top:0;">
      <div class="container-fluid">
        <div class="max-585">
          <div class="header-content">
            <h1>最佳机器学习产品创造者</h1>
            <p>测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据</p>
            <div class="button-group">
              <router-link :to="{path:'/'}" class="main-btn">开始</router-link>
              <router-link :to="{path:'/'}" class="main-btn main-btn-white">开始免费试用</router-link>
            </div>
          </div>
          <div class="clear"></div>
        </div>
      </div>
      <div class="header-image-shape">
        <img src="../../assets/interthings/header-shape.png">
      </div>
      <div class="clear"></div>
    </div>
    <div class="container">
      <div class="container-title">
        <h2>足够先进的技术</h2>
      </div>
      <div class="clear"></div>
      <div class="container">
        <div>
          <div class="col-lg-3 pb-30">
            <div class="feature-card">
              <div class="feature-card-header">
                <div class="feature-card-thumb feature-card-thumb-green">
                  <i class="flaticon-machine-learning-1"></i>
                </div>
                <span>机器学习技术</span>
              </div>
              <div class="feature-card-body">
                <p>测试数据测试数据测试数据测试数据测试数据测试数据测试数据</p>
                <router-link :to="{path:'/'}" class="redirect-link">
                  查看更多 <i class="icofont-rounded-right"></i>
                </router-link>
              </div>
            </div>
            <div class="clear"></div>
          </div>
          <div class="col-lg-3 pb-30">
            <div class="feature-card">
              <div class="feature-card-header">
                <div class="feature-card-thumb feature-card-thumb-yellow">
                  <i class="flaticon-voice-recognition"></i>
                </div>
                <span>ADI科技</span>
              </div>
              <div class="feature-card-body">
                <p>测试数据测试数据测试数据测试数据测试数据测试数据测试数据</p>
                <router-link :to="{path:'/'}" class="redirect-link">
                  查看更多 <i class="icofont-rounded-right"></i>
                </router-link>
              </div>
            </div>
            <div class="clear"></div>
          </div>
          <div class="col-lg-3 pb-30">
            <div class="feature-card">
              <div class="feature-card-header">
                <div class="feature-card-thumb feature-card-thumb-blue">
                  <i class="flaticon-machine-learning"></i>
                </div>
                <span>数据技术</span>
              </div>
              <div class="feature-card-body">
                <p>测试数据测试数据测试数据测试数据测试数据测试数据测试数据</p>
                <router-link :to="{path:'/'}" class="redirect-link">
                  查看更多 <i class="icofont-rounded-right"></i>
                </router-link>
              </div>
            </div>
            <div class="clear"></div>
          </div>
          <div class="col-lg-3 pb-30">
            <div class="feature-card">
              <div class="feature-card-header">
                <div class="feature-card-thumb feature-card-thumb-violet">
                  <i class="flaticon-processor"></i>
                </div>
                <span>人工智能技术</span>
              </div>
              <div class="feature-card-body">
                <p>测试数据测试数据测试数据测试数据测试数据测试数据测试数据</p>
                <router-link :to="{path:'/'}" class="redirect-link">
                  查看更多 <i class="icofont-rounded-right"></i>
                </router-link>
              </div>
            </div>
            <div class="clear"></div>
          </div>
        </div>
        <div class="clear"></div>
      </div>
    </div>
    <div class="bg-off-white">
      <div class="container">
        <div>
          <div class="col-lg-6 pb-30">
            <div class="text-center">
              <img src="../../assets/interthings/feature-shape-1.png">
            </div>
            <div class="clear"></div>
          </div>
          <div class="col-lg-6 pb-30">
            <div class="about-item-details">
              <div class="section-title">
                <h2>使命是将机器学习的力量带给每一个企业</h2>
              </div>
              <div class="about-content">
                <p>
                  测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据
                </p>
                <p>
                  测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据
                </p>
                <router-link :to="{path:'/'}" class="main-btn">关于我们</router-link>
              </div>
            </div>
          </div>
          <div class="clear"></div>
        </div>
      </div>
      <div class="clear"></div>
    </div>
    <div>
      <div class="container">
        <div class="section-title section-title-lg">
          <h2>我们的目标是提供卓越的服务<br> 在服务与执行中</h2>
          <p>
            我们的目的是提供卓越的服务和执行 我们的目的是提供卓越的服务 我们的目的是提供卓越的服务。
           </p>
        </div>
        <div>
          <div class="col-lg-4 pb-30">
            <div class="service-card">
              <div class="service-card-thumb">
                <i class="flaticon-automation"></i>
              </div>
              <div class="service-card-body">
                <h3>机器人自动化</h3>
                <p>测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据</p>
                <router-link :to="{path:'/'}" class="redirect-link">
                  查看更多 <i class="icofont-rounded-right"></i>
                </router-link>
              </div>
            </div>
          </div>
          <div class="col-lg-4 pb-30">
            <div class="service-card">
              <div class="service-card-thumb">
                <i class="flaticon-predictive-chart"></i>
              </div>
              <div class="service-card-body">
                <h3>预测分析</h3>
                <p>测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据</p>
                <router-link :to="{path:'/'}" class="redirect-link">
                  查看更多 <i class="icofont-rounded-right"></i>
                </router-link>
              </div>
            </div>
          </div>
          <div class="col-lg-4 pb-30">
            <div class="service-card">
              <div class="service-card-thumb">
                <i class="flaticon-deep-learning"></i>
              </div>
              <div class="service-card-body">
                <h3>深度学习</h3>
                <p>测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据</p>
                <router-link :to="{path:'/'}" class="redirect-link">
                  查看更多 <i class="icofont-rounded-right"></i>
                </router-link>
              </div>
            </div>
          </div>
          <div class="col-lg-4 pb-30">
            <div class="service-card">
              <div class="service-card-thumb">
                <i class="flaticon-data-mining"></i>
              </div>
              <div class="service-card-body">
                <h3>数据挖掘</h3>
                <p>测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据</p>
                <router-link :to="{path:'/'}" class="redirect-link">
                  查看更多 <i class="icofont-rounded-right"></i>
                </router-link>
              </div>
            </div>
          </div>
          <div class="col-lg-4 pb-30">
            <div class="service-card">
              <div class="service-card-thumb">
                <i class="flaticon-diagram"></i>
              </div>
              <div class="service-card-body">
                <h3>统计建模</h3>
                <p>测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据</p>
                <router-link :to="{path:'/'}" class="redirect-link">
                  查看更多 <i class="icofont-rounded-right"></i>
                </router-link>
              </div>
            </div>
          </div>
          <div class="col-lg-4 pb-30">
            <div class="service-card">
              <div class="service-card-thumb">
                <i class="flaticon-machine-learning-2"></i>
              </div>
              <div class="service-card-body">
                <h3>安全监控</h3>
                <p>测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据测试数据</p>
                <router-link :to="{path:'/'}" class="redirect-link">
                  查看更多 <i class="icofont-rounded-right"></i>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="clear"></div>
    </div>
    <div class="bg-off-white">
      <div class="container">
        <div class="section-title section-title-lg">
          <h2>公司新闻</h2>
        </div>
        <div>
          <div class="col-lg-4 pb-30">
            <div class="blog-card">
              <div class="blog-card-image">
                <router-link :to="{path:'/'}">
                  <img src="../../assets/interthings/blog-1.jpg" alt="blog">
                </router-link>
              </div>
              <div class="blog-card-text">
                <div class="blog-category">技术</div>
                <h3>
                  <router-link :to="{path:'/'}">机器学习是正确的吗？</router-link>
                </h3>
              </div>
            </div>
          </div>
          <div class="col-lg-4 pb-30">
            <div class="blog-card">
              <div class="blog-card-image">
                <router-link :to="{path:'/'}">
                  <img src="../../assets/interthings/blog-2.jpg" alt="blog">
                </router-link>
              </div>
              <div class="blog-card-text">
                <div class="blog-category">机器人</div>
                <h3>
                  <router-link :to="{path:'/'}">人工智能信息图的现状</router-link>
                </h3>
              </div>
            </div>
          </div>
          <div class="col-lg-4 offset-md-3 offset-lg-0 pb-30">
            <div class="blog-card">
              <div class="blog-card-image">
                <router-link :to="{path:'/'}">
                  <img src="../../assets/interthings/blog-3.jpg" alt="blog">
                </router-link>
              </div>
              <div class="blog-card-text">
                <div class="blog-category">机器</div>
                <h3>
                  <router-link :to="{path:'/'}">公司是大数据领域的全球领导者</router-link>
                </h3>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="clear"></div>
    </div>
    <Footer/>
  </div>
</template>
<script>
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import Navigationzj from '@/components/Navigationzj'

export default {
  name: 'Interthings',
  components: {
    Header,
    Navigationzj,
    Footer
  },
  data () {
    return {
      qyloading: false
    }
  },
  mounted () {
  },
  methods: {
  }
}
</script>
<style scoped>
.clear {
  clear: both;
}
.h_zp_zx {
  width: 1200px;
  padding-top: 220px;
  padding-bottom: 160px;
  position: relative;
  background-image: url(../../assets/interthings/header-bg-shape.png);
  background-size: 100%;
  background-repeat: no-repeat;
  background-position: center bottom;
  border-bottom: 1px solid #eee;
}
.container-fluid {
  width: 100%;
  margin-right: auto;
  margin-left: auto;
}
.max-585 {
  max-width: 585px;
}
.header-content {
  position: relative;
  z-index: 11;
  padding-left: 25px;
}
.header-content h1 {
  font-size: 50px;
  margin-bottom: 10px
}
.header-content p {
  font-size: 18px;
  margin-bottom: 25px;
  color: #767676;
  line-height: 1.6;
}
.button-group .main-btn {
  margin-right: 25px;
  margin-top: 20px;
}
.main-btn {
  padding: 15px 50px;
  text-align: center;
  color: #fff;
  font-size: 15px;
  font-weight: 700;
  border: 0;
  position: relative;
  border-radius: 35px;
  z-index: 0!important;
  background-color: #1f12fd;
  box-shadow: 0 7px 51px 0 rgba(31,18,253,.12);
}
.main-btn.main-btn-white {
  background-color: #fff;
  color: #1f12fd;
}
.main-btn.main-btn-white:hover {
  background-color: #1f12fd;
  color: #fff;
}
.header-image-shape {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 0;
}
.header-image-shape img {
  max-width: 850px;
}
.container {
  max-width: 1200px;
  margin: 0 auto;
  margin-top: 50px;
}
.container-title h2 {
  text-align: center;
  font-size: 36px;
  font-weight: 700;
  margin-bottom: 16px;
  position: relative;
  line-height: 1.4;
}
.container-title h2:last-child {
  margin-bottom: 0;
}
.pb-30 {
  padding-bottom: 30px;
  padding-right: 16px;
}
.pb-30:last-child {
  padding-right: 0;
}
.col-lg-3 {
  width: 24%;
  float: left;
}
.feature-card {
  padding: 30px;
  border-radius: 10px;
  -webkit-box-shadow: 0 9px 54px 0 rgba(32,32,32,.1);
  box-shadow: 0 9px 54px 0 rgba(32,32,32,.1);
  -webkit-transition: all .3s linear;
  transition: all .3s linear;
  background-color: #fff;
}
.feature-card:hover {
  -webkit-transform: translateY(-5px);
  transform: translateY(-5px);
}
.feature-card-header {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  margin-top: -15px;
  margin-bottom: 20px;
}
.feature-card-thumb.feature-card-thumb-green {
  background-color: rgba(53,231,149,.15);
  color: #56c5b2;
}
.flaticon-machine-learning-1 {
  width: 50px;
  height: 50px;
  background-image: url(../../assets/interthings/learning.png);
  background-size: 100%;
  background-repeat: no-repeat;
}
.flaticon-voice-recognition {
  width: 50px;
  height: 50px;
  background-image: url(../../assets/interthings/recognition.png);
  background-size: 100%;
  background-repeat: no-repeat;
}
.flaticon-machine-learning {
  width: 50px;
  height: 50px;
  background-image: url(../../assets/interthings/learning2.png);
  background-size: 100%;
  background-repeat: no-repeat;
}
.flaticon-processor {
  width: 50px;
  height: 50px;
  background-image: url(../../assets/interthings/processor.png);
  background-size: 100%;
  background-repeat: no-repeat;
}
.feature-card-thumb {
  border-radius: 10px;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 auto;
  flex: 0 0 auto;
  width: 60px;
  height: 60px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  margin-right: 20px;
  margin-top: 15px;
  font-size: 35px;
}
.feature-card-header span {
  color: #000;
  font-size: 22px;
  margin-top: 15px;
  font-weight: 600;
}
.feature-card-body p {
  margin-bottom: 15px;
}
p {
  color: #767676;
  line-height: 1.6;
}
.feature-card-body a {
  font-size: 14px;
  font-weight: 600;
  color: #1f12fd;
  transition: all .3s linear;
}
.feature-card-thumb.feature-card-thumb-yellow {
  background-color: rgba(232,201,30,.15);
  color: #e8c91e;
}
.feature-card-thumb.feature-card-thumb-blue {
  background-color: rgba(48,140,211,.15);
  color: #308cd3;
}
.feature-card-thumb.feature-card-thumb-violet {
  background-color: rgba(186,76,249,.15);
  color: #ba4cf9;
}
.bg-off-white {
  background-color: #f4f8ff;
}
.col-lg-6 {
  width: 48%;
  float: left;
}
.text-center {
  text-align: center;
  padding: 60px;
}
.about-item-details {
  margin-top: 220px;
}
.about-item-details .section-title {
  margin-bottom: 18px;
}
.section-title h1 {
  display: inline-block;
  font-size: 18px;
  margin-bottom: 15px;
  font-weight: 500;
  color: #1f12fd;
}
.section-title h2 {
  font-size: 36px;
  font-weight: 700;
  position: relative;
  line-height: 1.4;
}
.about-content p {
  margin-bottom: 25px;
}
.about-content ul {
  padding-left: 0;
  padding-right: 0;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  margin-bottom: 5px;
}
.about-content ul li {
  position: relative;
  font-size: 16px;
  margin-bottom: 10px;
  color: #000;
  list-style: none;
  padding-left: 30px;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 auto;
  flex: 0 0 auto;
  width: 50%;
  padding-right: 10px;
}
.main-btn:hover {
  color: #fff;
  background-color: #1509d8;
}
.section-title {
  text-align: center;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 50px;
}
.section-title p {
  font-size: 17px;
  font-weight: 400;
  margin-bottom: 30px;
  position: relative;
}
.col-lg-4 {
  width: 32%;
  float: left;
}
.service-card {
  border-radius: 10px;
  -webkit-box-shadow: 0 9px 54px 0 rgba(32,32,32,.1);
  box-shadow: 0 9px 54px 0 rgba(32,32,32,.1);
  padding: 30px;
  position: relative;
  overflow: hidden;
}
.service-card-thumb {
  border-radius: 10px;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 auto;
  flex: 0 0 auto;
  width: 125px;
  height: 125px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  font-size: 65px;
  background-color: #f6f6ff;
  color: #1f12fd;
  margin-bottom: 25px;
}
.flaticon-automation {
  width: 64px;
  height: 64px;
  background-image: url(../../assets/interthings/automation.png);
  background-size: 100%;
  background-repeat: no-repeat;
}
.flaticon-predictive-chart {
  width: 64px;
  height: 64px;
  background-image: url(../../assets/interthings/predictive-chart.png);
  background-size: 100%;
  background-repeat: no-repeat;
}
.flaticon-deep-learning {
  width: 64px;
  height: 64px;
  background-image: url(../../assets/interthings/deep-learning.png);
  background-size: 100%;
  background-repeat: no-repeat;
}
.flaticon-data-mining {
  width: 64px;
  height: 64px;
  background-image: url(../../assets/interthings/data-mining.png);
  background-size: 100%;
  background-repeat: no-repeat;
}
.flaticon-diagram {
  width: 64px;
  height: 64px;
  background-image: url(../../assets/interthings/diagram.png);
  background-size: 100%;
  background-repeat: no-repeat;
}
.flaticon-machine-learning-2 {
  width: 64px;
  height: 64px;
  background-image: url(../../assets/interthings/machine-learning-2.png);
  background-size: 100%;
  background-repeat: no-repeat;
}
.service-card-body h3 {
  font-size: 22px;
  line-height: 1.4;
  margin-bottom: 15px;
  -webkit-transition: all .3s linear;
  transition: all .3s linear;
  -webkit-transition-delay: .1s;
  transition-delay: .1s;
}
.service-card-body p {
  margin-bottom: 15px;
  -webkit-transition: all .3s linear;
  transition: all .3s linear;
  -webkit-transition-delay: .1s;
  transition-delay: .1s;
}
.service-card-body a {
  font-size: 15px;
  -webkit-transition: all .3s linear;
  transition: all .3s linear;
  -webkit-transition-delay: .1s;
  transition-delay: .1s;
  font-weight: 500;
}
.service-card:hover:before {
  opacity: 1;
  width: 100%;
  height: 100%;
  border-radius: 0;
}
.service-card:before {
  content: "";
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: #1f12fd;
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
  -webkit-transition: all .3s linear;
  transition: all .3s linear;
  z-index: -1;
}
.service-card:hover .service-card-body h3 {
  color: #fff;
}
.service-card:hover .service-card-body p {
  color: #fff;
}
.service-card:hover .service-card-body a {
  color: #fff;
}
.section-title.section-title-lg {
  padding-top: 20px;
  max-width: 825px;
}
.blog-card {
  padding: 10px 10px 23px;
  border-radius: 10px;
  -webkit-box-shadow: 0 9px 54px 0 rgba(32,32,32,.1);
  box-shadow: 0 9px 54px 0 rgba(32,32,32,.1);
  background-color: #fff;
  -webkit-transition: all .3s linear;
  transition: all .3s linear;
  position: relative;
}
.blog-card-image {
  border-radius: 10px 10px 0 0;
  overflow: hidden;
  margin-bottom: 23px;
  position: relative;
}
.blog-card-image img {
  -webkit-transition: all .5s ease-in-out;
  transition: all .5s ease-in-out;
}
.blog-card-text {
  padding-left: 15px;
  padding-right: 15px;
}
.blog-category {
  padding: 6px 20px;
  background-color: #e7e5ff;
  color: #1f12fd;
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 18px;
  display: inline-block;
  border-radius: 25px;
}
.blog-card-text h3 {
  font-size: 22px;
  line-height: 1.4;
  margin-bottom: 20px;
}
.blog-card-text h3 a {
  color: #000;
}
img {
  max-width: 100%;
  height: auto;
}
.blog-card:hover {
  -webkit-transform: translateY(-10px);
  transform: translateY(-10px);
}
.blog-card:hover .blog-card-image img {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
.blog-card:hover .blog-card-text a {
  color: #1f12fd;
  text-decoration:underline;
}
</style>



// WEBPACK FOOTER //
// src/view/interthings/index.vue